/* eslint-disable import/prefer-default-export */
// step 2
export const initialSummaryState = {};
